export default __webpack_public_path__ + "012e9caf45a3bad759ab5870d82b88c8.png";